export { StorageModule } from './src/storage.module';

export { CookieService } from './src/service/cookie.service';
export { LocalStorageService } from './src/service/local-storage.service';
export { SessionStorageService } from './src/service/session-storage.service';

export { Cookie } from './src/model/cookie';

export { StorageKey } from './src/interface/storage-key.interface';
export { StorageProvider } from './src/interface/storage-provider.interface';
